import React, { useEffect } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
const PIXEL_ID = '2268210303957960';
const META_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  useEffect(() => {
    const f = window as any;
    const b = document;
    if (!f.fbq) {
      const n: any = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      if (!b.getElementById(META_SCRIPT_ID)) {
        const t = b.createElement('script');
        t.id = META_SCRIPT_ID;
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = b.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      }
      f.fbq('init', PIXEL_ID);
    }
    f.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-113" data-mp="13goqbd7xv2uu">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-114" data-mp="13gx5xcvg4m9q" />
    </noscript>;
}